import { Content } from '../../types';

export const khlongMaeKhaContent: Content = {
  title: "Khlong Mae Kha - פנינת חן נסתרת בצ'אנג מאי",
  imageUrl: '/images/thailand/khlong-mae-kha/khlong-mae-kha-wide.jpeg',
  introduction: `בלב העיר צ'אנג מאי, בצידה הדרום-מזרחי של העיר, סמוך לרחוב Ragang, נמצא אחד האזורים המתחדשים והמרתקים ביותר בעיר - Khlong Mae Kha. המקום, אשר לאורך שנים היה מוזנח, עבר תהליך שיקום מקיף והפך לאטרקציה תיירותית קסומה, השומרת על אופייה הכפרי והאותנטי של צ'אנג מאי.`,
  sections: [
    {
      title: 'היסטוריה ושיקום התעלה',
      content: `Khlong Mae Kha הינו אזור הבנוי משני צידי תעלת מים ציורית, הנחשבת לאחד מיובליו של נהר ה-Ping, הנהר המרכזי הזורם לאורך העיר. בעבר, היה המקום אזור מוזנח וסבל מהצטברות פסולת וזיהום מים, אך בשנים האחרונות השקיעה הרשות המקומית משאבים רבים בשיקום התעלה והפיכתה למתחם מרהיב, נקי ומזמין.`,
      type: 'text',
    },
    {
      title: 'אטרקציות ופעילויות',
      content: `כיום, האזור מציע שוק לילה תוסס עם מגוון רחב של מסעדות קטנות, בתי קפה אינטימיים, דוכני מזכרות, עבודות אמנות ומלאכת יד של התושבים המקומיים. המבקרים יכולים ליהנות משיטוט רגוע לאורך התעלה, להתרשם מהאדריכלות הכפרית המשולבת עם אלמנטים מודרניים ולחוות את האווירה הייחודית והשלווה השוררת במקום.`,
      type: 'text',
    },
    {
      title: 'פסטיבל Loy Krathong',
      content: `אחד משיאי הביקור באזור הוא חגיגות פסטיבל Loy Krathong, הנערך מדי שנה בנובמבר. במהלך הפסטיבל, המקום מתמלא באור נרות צפים על פני המים, מוסיקה מסורתית ואווירה חגיגית מרהיבה ההופכת את הביקור ב-Khlong Mae Kha לחוויה בלתי נשכחת.`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, במידה והינכם מחפשים מקום אותנטי ושקט לטיול ערב רומנטי, חוויית קניות מקומית או פשוט פינה קסומה להירגע בה - Khlong Mae Kha הוא יעד מומלץ במיוחד לכל מי שמבקר בצ'אנג מאי.
<br />ובנימה אישית שלנו, אל תפספסו את האתר הזה, דגש על הגעה כשעה לפני השקיעה!`,
      type: 'text',
      isBold: true,
    },
  ],
};
